<template>
    <div class="legal-midea-pay-dialog">
        <el-dialog
            title="法人注册美的付"
            :visible.sync="visible"
            style="min-width: 1200px;"
            :before-close="handleClose">
            <div class="legal-midea-pay-content" v-loading="loading">
                <el-row>
                    <el-col :span="7">美的付账号：</el-col>
                    <el-col :span="12">{{ formData.payBankAccount }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="7">美的付审核状态：</el-col>
                    <el-col :span="12">{{ formData.payAuditStatusText }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="7">美的付审核状态描述：</el-col>
                    <el-col :span="12">{{ formData.payAuditReason }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="7">美的付审核状态时间：</el-col>
                    <el-col :span="12">{{ formData.payAuditTime }}</el-col>
                </el-row>
            </div>
            <!-- <div ref="iframeRef"></div> -->
            <div id="legal-midea-pay"></div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" :loading="confirmLoading" :disabled="registerDisabled" @click="handleConfirm">点击注册</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { legalMideaPayRegister } from '../../../../../../api/finance.js';
import { getSupplierInfo } from '../../../../../../api/keyDataDetail.js';
import { dictWithUrl } from '@/components/lots/api';

export default {
    name: 'legal-midea-pay-dialog',
    components: { },
    props: {
        supplierCode: {
            type: String,
            default: () => null
        },
        visible: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            loading: false,
            confirmLoading: false,
            dict: {},
            formData: {
                payBankAccount: '',
                payAuditStatus: '',
                payAuditStatusText: '',
                payAuditReason: '',
                payAuditTime: ''
            },
            registerDisabled: true,
            html: ''
        };
    },
    methods: {
        handleClose() {
            this.formData = {
                payBankAccount: '',
                payAuditStatus: '',
                payAuditStatusText: '',
                payAuditReason: '',
                payAuditTime: ''
            };
            this.registerDisabled = true;
            this.$emit('close');
        },
        handleConfirm () {
            this.confirmLoading = true;
            legalMideaPayRegister({ supplierCode: this.supplierCode }).then(res => {
                if (res && +res.code === 0) {
                    document.getElementById('legal-midea-pay').innerHTML = res.data;
                    /* eslint-disable-next-line no-eval */
                    eval(res.data.match(/<script>(\S*)<\/script>/)[1]);
                }
            }).finally(() => { this.confirmLoading = false; });
        },
        getInfo() {
            const isSupplier = this.$store.state.supplier;
            if (isSupplier) {
                this.setPayData(isSupplier);
                return false;
            }
            this.loading = true;
            const params = { ...this.$route.query };
            params.businessType = params.businessType === 'null' ? '' : params.businessType;
            getSupplierInfo(params).then(res => {
                if (res && +res.code === 0) {
                    this.setPayData(res.data);
                }
            }).finally(() => { this.loading = false; });
        },
        setPayData(data) {
            this.formData = {
                payBankAccount: data.payBankAccount,
                payAuditStatus: data.payAuditStatus,
                payAuditStatusText: data.payAuditStatus ? this.dict.SRM_PAY_AUDIT_STATUS[data.payAuditStatus] : '',
                payAuditReason: data.payAuditReason,
                payAuditTime: data.payAuditTime
            };
            this.registerDisabled = ['AUDIT_ING', 'CONSENT'].includes(data.payAuditStatus);
        }
    },
    // mounted() { },
    watch: {
        visible(val) {
            if (val) {
                dictWithUrl('SRM_PAY_AUDIT_STATUS').then(res => {
                    if (res && +res.code === 0) {
                        this.dict = res.data || {};
                        this.getInfo();
                    }
                });
            }
        }
    }
};
</script>
<style lang="less">
.legal-midea-pay-dialog {
    .legal-midea-pay-content {
        font-size: 14px;
        .el-row {
            margin-bottom: 10px;
            .el-col-7 {
                text-align: right;
            }
        }
    }
}
</style>
